import { render, staticRenderFns } from "./CallMethod.vue?vue&type=template&id=52dfb9ce&scoped=true"
import script from "./CallMethod.vue?vue&type=script&lang=js"
export * from "./CallMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfb9ce",
  null
  
)

export default component.exports